<template>
  <div class="prm-client padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="clientsTypeArr" @change="fetchData(1)" />
        </span>
        <div class="filter-item sm">
          <partner-level-selector v-model="query.customer_level" @change="fetchData(1)" />
        </div>
        <div class="filter-item sm">
          <f-member-selector v-model="query.memberid" placeholder="关联用户" @change="fetchData(1)" />
        </div>
        <div class="filter-item sm">
          <f-search-input v-model="query.keyword" width="160" placeholder="名称" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
      <div class="toolbox">
        <el-link :underline="false" type="warning" @click="toDoc">
          <i class="el-icon-question font-md" />
          如何创建客户
        </el-link>
        <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml" @change="sortChange" />
      </div>
    </div>
    <el-card v-loading="loading" shadow="never" class="card mb-md">
      <el-table ref="listTable" :data="list" tooltip-effect="dark">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column width="60">
          <div class="customer-icon text-blue radius5" slot-scope="scope">
            <div class="iconfont icon-customer"></div>
          </div>
        </el-table-column>

        <el-table-column label="客户" min-width="220">
          <div slot-scope="scope" class="company-box">
            <div class="mb-xs">{{ scope.row.company_name }}</div>
            <span class="text-muted font-sm">{{ scope.row.credit_code }}</span>
          </div>
        </el-table-column>
        <el-table-column label="等级" min-width="80">
          <template slot-scope="scope">
            <span>{{ partnerLevelObj[scope.row.customer_level] ? partnerLevelObj[scope.row.customer_level] : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 30" type="success">服务中</el-tag>
            <el-tag v-else-if="scope.row.status == 10" type="warning">待审核</el-tag>
            <el-tag v-else-if="scope.row.status == 40" type="danger">已流失</el-tag>
            <el-tag v-else-if="scope.row.status == 50" type="info">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="设备数量" min-width="100" align="center">
          <template slot-scope="scope">
            <span class="font-lg text-black">{{ scope.row.equip_count }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="关联用户">
          <template slot-scope="scope">
            <el-popover placement="right-start" :width="600" trigger="hover" :visible-arrow="false" @hide="handlePopoverHide">
              <el-table :data="scope.row.members" :max-height="350" style="width: 100%;">
                <el-table-column type="index" label="#" width="50" />
                <el-table-column min-width="90" align="right">
                  <template slot-scope="scope">
                    <f-user-avatar :src="scope.row.avatar" />
                  </template>
                </el-table-column>
                <el-table-column label="昵称" min-width="130" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <f-user-name :user="scope.row" class="ellipsis" style="display: block;" />
                  </template>
                </el-table-column>
                <el-table-column label="备注" min-width="100" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.remark }}
                  </template>
                </el-table-column>
                <el-table-column label="缺省权限" min-width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.default_auth"
                      type="success"
                      style="cursor: pointer;"
                      @click="setDefaultAuth(scope.row)"
                    >
                      {{ authObj[scope.row.default_auth].title }}
                    </el-tag>
                    <el-button v-else type="text" @click="setDefaultAuth(scope.row)">设置</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div slot="reference">
                <f-user-avatar v-for="user in scope.row.members.slice(0, 3)" class="mr-xs" :key="user.memberid" :src="user.avatar" />
                <span v-if="scope.row.members.length > 3" class="text-black">等{{ scope.row.members.length }}人</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="创建日期" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openClientSettingDialog(scope.row)">设置</el-button>
          </template>
        </el-table-column>

        <template slot="append">
          <div class="foot-menu" :class="!collapse && 'active'">
            <f-table-footer>
              <template slot="right">
                <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
              </template>
            </f-table-footer>
          </div>
        </template>

        <div v-if="!loading" slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>
    <ClientSettingDialog v-if="clientSettingDialogShow" :show.sync="clientSettingDialogShow" :company_name="company_name" :customer_level="customer_level" :customer_id="customer_id" @success="fetchData(1)" />
    <DefaultAuthDialog v-if="defaultAuthDialogShow" :show.sync="defaultAuthDialogShow" :row="currentMember" @success="fetchData(1)" />
  </div>
</template>

<script>
import { getCustomerListApi } from "@/api/prm/prmClientApi"
import PartnerTag from "./components/PartnerTag.vue"

export default {
  name: "PrmClient",
  data() {
    return {
      clientsTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 10, title: "待审核" },
        { value: 30, title: "服务中" },
        { value: 40, title: "已流失" },
        { value: 50, title: "无效" },
      ],
      sortOptions: [
        { value: 1, title: "最近创建" },
        { value: 2, title: "最早创建" },
        { value: 3, title: "最高等级" },
        // { value: 4, title: "最多设备" },
      ],
      memberList: [],
      loading: false,
      total: 0,
      query: {
        status: 0,
        customer_level: null,
        sort: +localStorage.getItem('__PRM_CLIENT_SORT__') || 1,
        keyword: '',
        memberid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      clientSettingDialogShow: false,
      customer_level: null,
      customer_id: null,
      company_name: '',
      defaultAuthDialogShow: false,
      currentMember: null,
    }
  },
  components: {
    PartnerTag,
    PartnerLevelSelector: () => import("./components/PartnerLevelSelector.vue"),
    ClientSettingDialog: () => import("./components/ClientSettingDialog.vue"),
    DefaultAuthDialog: () => import("@/views/up/components/DefaultAuthDialog.vue"),
  },
  mounted() {
    this.fetchData(1)
  },
  computed: {
    authObj() {
      return this.$store.getters.authObj
    },
    partnerLevelObj() {
      return this.$store.getters.partnerLevelObj
    },
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
  },
  methods: {
    fetchData(page) {
      if (page) {
        this.query.pindex = page
      }
      this.loading = true
      getCustomerListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    sortChange(val) {
      this.query.sort = val.value
      localStorage.setItem('__PRM_CLIENT_SORT__', val.value)
      this.fetchData(1)
    },
    setDefaultAuth(row) {
      this.currentMember = row
      this.defaultAuthDialogShow = true
    },
    toDoc() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/28");
    },
    handlePopoverHide() {
      // 修复 el-popover 关闭时 aria-hidden 警告
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur()
      }
    },
    openClientSettingDialog(row) {
      this.customer_level = row.customer_level
      this.customer_id = row.customer_id
      this.company_name = row.company_name
      this.clientSettingDialogShow = true
    },
  },
}
</script>

<style scoped lang="scss">
.prm-client {
  padding-bottom: 70px;

  .customer-icon {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    background-color: #F3F4F6;
  }

  .company-box {
    line-height: 1;
  }

  .foot-menu {
    position: fixed;
    background-color: #fff;
    bottom: 0;
    left: 240px;
    width: calc(100% - 240px);
    z-index: 3;
    padding-left: 20px;
    padding: 4px 30px 5px 20px;

    &.active {
      left: 340px;
      width: calc(100% - 340px);
    }

    .f-table-footer {
      margin: 0;
      height: 50px;
    }
  }
}
</style>
